import { useNavigate } from 'react-router-dom'


const GoToBack = ({ url, extraClassName = '' }) => {
    const navigate = useNavigate()


    return (
        <button type='button' className={`Button-Return ${extraClassName && extraClassName !== '' && ( extraClassName )}`} onClick={() => navigate(url)}><i className="bi bi-caret-left-fill"></i></button> // bi-arrow-90deg-left
    )
}

export { GoToBack };